export enum EGender {
  Female = 'FEMININO',
  Male = 'MASCULINO',
}
